import Vue from "vue";
import VueRouter from "vue-router";
import Signup from "../views/Signup.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: () => localStorage.getItem("token") ? "/app/dashboard" : "/login" },
  { path: "/login",             name: "Login",           component: () => import("../views/Login.vue") },
  { path: "/forgot-password",  name: "ForgotPassword",  component: () => import("../views/ForgotPassword.vue") },
  { path: "/reset-password",   name: "ResetPassword",   component: () => import("../views/ResetPassword.vue") },
  { path: "/signup",            name: "Signup",          component: Signup },
  { path: "/signup/success",    name: "SignupSuccess",   component: () => import("../views/SignupSuccess.vue") },

  // Backward compat redirect
  { path: "/dashboard", redirect: "/app/dashboard" },

  // Authenticated app shell
  {
    path: "/app",
    component: () => import("../components/AppLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      { path: "",                    redirect: "dashboard" },
      { path: "dashboard",           name: "Dashboard",       component: () => import("../views/dashboard/Dashboard.vue") },
      { path: "companies/:cik",      name: "CompanyDetail",   component: () => import("../views/CompanyDetail.vue") },
      { path: "investors",           name: "Investors",       component: () => import("../views/Investors.vue") },
      { path: "investors/:filer_cik",name: "InvestorDetail",  component: () => import("../views/InvestorDetail.vue") },
      { path: "watchlist",           name: "Watchlist",       component: () => import("../views/Watchlist.vue") },
      { path: "filings",             name: "Filings",         component: () => import("../views/Filings.vue") },
      { path: "notifications",       name: "Notifications",   component: () => import("../views/Notifications.vue") },
      { path: "profile",             name: "Profile",         component: () => import("../views/Profile.vue") },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((r) => r.meta.requiresAuth);
  const token = localStorage.getItem("token");
  if (requiresAuth && !token) {
    next("/login");
  } else if (!requiresAuth && token && ["/", "/login", "/forgot-password", "/reset-password"].includes(to.path)) {
    next("/app/dashboard");
  } else {
    next();
  }
});

export default router;
